import React from 'react';
import styled from 'styled-components';
import { Input as I, Form as F } from 'semantic-ui-react';

class GetInTouch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      FirstName: '',
      LastName: '',
      _replyto: '',
      _subject: '',
      message: ''
    };
  }

  handleChange = ({ target: { name, value } }) =>
    this.setState({ [name]: value, [`${name}Error`]: false });

  handleSubmit = (e) => {
    let isOkay = true;
    const {
      FirstName, LastName, _replyto, _subject, message
    } = this.state;
    const details = {
      FirstName,
      LastName,
      _replyto,
      _subject,
      message
    };
    Object.keys(details).forEach((key) => {
      if (!this.state[key]) {
        isOkay = false;
        this.setState({ [`${key}Error`]: true });
      }
    });

    if (!isOkay) {
      console.log('here');
      e.preventDefault();
    }
  };

  render() {
    const {
      FirstName,
      LastName,
      _replyto,
      _subject,
      message,
      FirstNameError,
      LastNameError,
      _replytoError,
      _subjectError
    } = this.state;
    return (
      <Container>
        <Row>{this.props.CalltoAction}</Row>
        <Form
          method="POST"
          action="https://formspree.io/h.r.rishi@observe.tech"
          onSubmit={this.handleSubmit}
        >
          <Inputs>
            <Field error={FirstNameError}>
              <label>{this.props.ContactFirst}</label>
              <Input
                type="text"
                name="FirstName"
                placeholder={this.props.ContactFirst}
                onChange={this.handleChange}
              />
            </Field>
            <Field error={LastNameError}>
              <label>{this.props.ContactLast}</label>
              <Input
                type="text"
                name="LastName"
                placeholder={this.props.ContactLast}
                onChange={this.handleChange}
              />
            </Field>
            <Field error={_replytoError}>
              <label>{this.props.ContactEmail}</label>
              <Input
                type="email"
                name="_replyto"
                placeholder={this.props.ContactEmail}
                onChange={this.handleChange}
              />
            </Field>
            <Field error={_subjectError}>
              <label>{this.props.ContactSub}</label>
              <Input
                name="_subject"
                placeholder={this.props.ContactSub}
                onChange={this.handleChange}
              />
            </Field>
          </Inputs>
          <F.Field style={{ width: '100%' }}>
            <label>{this.props.ContactContent}</label>
            <Textarea
              type="text"
              name="message"
              placeholder={this.props.ContactContent}
              onChange={this.handleChange}
            />
          </F.Field>
          {/* <Row> */}
          <Button>{this.props.ContactSubmit}</Button>
          {/* </Row> */}
          <input type="hidden" name="_next" value="//observe.tech" />
        </Form>
      </Container>
    );
  }
}

export default GetInTouch;

const Container = styled.div`
  width: 100%;
  /* min-height: calc(100vh - 70px); */
  padding: 2rem 0;
  background: #262936;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 950px) {
    min-height: calc(100vh - 50px);
  }
`;
const Row = styled.div`
  width: 100%;
  // height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5rem;
  line-height: 3.5rem;
  color: #63a9be;
  margin-bottom: 2rem;
  /* padding: 4rem 0; */
  @media (max-width: 950px) {
    /* height: 100px; */
  }
`;

const Form = styled(F)`
  width: 100%;
  max-width: 800px !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  label {
    color: rgb(102, 109, 137) !important;
    font-size: 1.4rem !important;
  }
  @media (max-width: 950px) {
    width: 90%;
    justify-content: center;
  }
  @media (max-width: 400px) {
    width: 90%;
  }
`;
const Inputs = styled.div`
  width: 100%;
  // height: 110px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-around;
  @media (max-width: 400px) {
    // height: 200px;
  }
`;

const Field = styled(F.Field)`
  width: calc(50% - 5px) !important;
  @media (max-width: 400px) {
    width: 100% !important;
  }
`;

const Input = styled(I)`
  //
  input {
    height: 45px !important;
    border-radius: 5px !important;
    background: #e9edef !important;
    border: 2px solid rgba(255, 255, 255, 0) !important;
    font-size: 20px !important;
    padding-left: 20px !important;
    &:focus {
      outline: none !important;
      // border: 2px solid #4babc0 !important;
    }
    @media (max-width: 400px) {
      width: 100% !important;
    }
  }
`;
const Textarea = styled.textarea`
  width: 100% !important;
  height: calc(100% - 315px) !important;
  margin-top: 5px !important;
  background: #e9edef !important;
  border: 2px solid rgba(255, 255, 255, 0) !important;
  border-radius: 5px !important;
  resize: none !important;

  font-size: 20px;
  padding: 20px;
  &:focus {
    outline: none;
    border: 2px solid #4babc0;
  }
  @media (max-width: 950px) {
  }
  @media (max-width: 400px) {
    height: calc(100% - 350px);
  }
`;

const Button = styled.button`
  width: 250px;
  height: 60px;
  background: #4babc0;
  background: #667db6; /* fallback for old browsers */
  background: linear-gradient(to right, #4babc0, #0082c8);
  font-size: 25px;
  line-height: 25px;
  color: white;
  display: flex;
  justify-content: center;
  border-radius: 35px;
  align-items: center;
  cursor: pointer;
  border: none;
  transition: 0.5s ease-out;
  &:focus {
    outline: none;
    border: none;
  }
  &:hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  }
`;



// WEBPACK FOOTER //
// ./src/components/GetInTouch/index.js